export default {
    setValue(keyName, keyValue){
        if(window._APP){
            window._APP.setParam(keyName, keyValue.toString());
        }else{
            window.localStorage.setItem(keyName, keyValue.toString());
        }
    },
    getValue(keyName){
        if(window._APP){
            return window._APP.getParam(keyName);
        }else{
            return window.localStorage.getItem(keyName);
        }
    },
    //获取url参数
    getUrlParam(name) {
        let regObj = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let matchResult = window.location.search.substr(1).match(regObj);
        if (matchResult != null) {
            return decodeURIComponent(matchResult[2]);
        }
        return null;
    },
}



// WEBPACK FOOTER //
// ./src/commonjs/store.js